export default "__VITE_ASSET__BRcu13sL__"